import { createContext, useState, useContext } from "react";
import useAgreementValues from "./agreementValues";

export const LoanApplicationContext = createContext(null);

export function LoanApplicationContextProvider({ children }) {
  const [agreements, setAgreements] = useState([]);
  const { agreementValues, setAgreementValues } = useAgreementValues();

  return (
    <LoanApplicationContext.Provider
      value={{
        agreements,
        setAgreements,
        agreementValues,
        setAgreementValues,
      }}
    >
      {children}
    </LoanApplicationContext.Provider>
  );
}

export function useLoanApplicationContext() {
  const value = useContext(LoanApplicationContext);
  if (!value) {
    throw new Error("LoanApplication context Provider is not defined");
  }
  return value;
}
